/* ==========================================================================
   Required personalisation guard — U&S Clothing
   assets/require-artwork.js

   Products with personalisation could be added to the cart with the fields
   left empty, and could be bought outright through Shop Pay without the cart
   ever being involved. Both routes reach production with nothing to print.

   The theme's own guard only covers one case:

       if (fileInput.files.length > 0 && cartProp.value === '')

   That is "a file was chosen but has not finished uploading". Choosing no
   file at all fails the first half, so the form submits untouched. The
   dynamic checkout buttons never submit the form, so they skip it entirely.

   Rather than fading the buttons and explaining only after a click, the
   buttons are removed from view until there is something to print, and a
   line takes their place saying what is still needed. Nothing in
   sections/main-product.liquid is edited.
   ========================================================================== */
(function () {
  'use strict';

  /* Run once per page. */
  if (window.__raGuardLoaded) return;
  window.__raGuardLoaded = true;


  /* ---------------------------------------------------------- what's missing */

  /* An upload zone is present and its cart property is still empty.
     Covers the theme's original block and the inline one. */
  function imageMissing() {
    var checks = [
      { zone: '.pib-wrapper', prop: 'input[name="properties[Custom Image]"]' },
      { zone: '.pi-image',    prop: 'input[name="properties[Image]"]' }
    ];
    for (var c = 0; c < checks.length; c++) {
      var zones = document.querySelectorAll(checks[c].zone);
      for (var i = 0; i < zones.length; i++) {
        var z = zones[i];
        if (!z.offsetParent && getComputedStyle(z).display === 'none') continue;
        var prop = z.querySelector(checks[c].prop) || document.querySelector(checks[c].prop);
        if (!prop) continue;
        if (!String(prop.value).trim()) return true;
      }
    }
    return false;
  }

  /* A visible personalisation text box that has been left blank. Hidden
     inputs are skipped — the inline block stores font, colour and position
     in those, and they are always filled. */
  function textMissing() {
    var fields = document.querySelectorAll(
      '.product__personalize-input input[name^="properties["], ' +
      '.product__personalize-input textarea[name^="properties["]'
    );
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f.type === 'hidden') continue;
      if (!f.offsetParent) continue;                 /* not on screen */
      if (!String(f.value).trim()) return true;
    }
    return false;
  }

  function hasAnyFields() {
    return !!document.querySelector(
      '.pib-wrapper, .pi-image, .product__personalize-input'
    );
  }

  function whatIsMissing() {
    var img = imageMissing();
    var txt = textMissing();
    if (!img && !txt) return null;
    if (img && txt) return 'Add your text and upload your Image to unlock the Add to Cart and Buy Now buttons.';
    if (img) return 'Upload your Image to unlock the Add to Cart and Buy Now buttons.';
    return 'Add your text to unlock the Add to Cart and Buy Now buttons.';
  }

  /* ------------------------------------------------------------------ notice */

  /* The message goes where the buttons were, so the shopper's eye lands on
     the explanation rather than on an empty space. */
  function noticeFor(form) {
    var box = form.querySelector('.artwork-required');
    if (box) return box;

    box = document.createElement('p');
    box.className = 'artwork-required';
    box.setAttribute('role', 'status');

    var anchor = form.querySelector('.product-form__buttons')
              || form.querySelector('.product-form__submit');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(box, anchor);
    } else {
      form.appendChild(box);
    }
    return box;
  }

  function forms() {
    return document.querySelectorAll('form[action*="/cart/add"]');
  }

  function refresh() {
    if (!hasAnyFields()) return;
    var message = whatIsMissing();

    Array.prototype.forEach.call(forms(), function (form) {
      var box = noticeFor(form);

      if (message) {
        box.textContent = message;
        box.hidden = false;
        form.classList.add('artwork-blocked');
      } else {
        box.hidden = true;
        form.classList.remove('artwork-blocked');
      }
    });

    document.querySelectorAll('.pib-wrapper, .pi-image').forEach(function (z) {
      z.classList.toggle('artwork-missing', imageMissing());
    });
  }

  /* ------------------------------------------------------------- the guards */

  /* Hiding the buttons is the main defence, but a stale class or a script
     that submits the form directly would slip past CSS alone. These catch
     that case too. */
  function isAddToCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.getAttribute('data-type') === 'add-to-cart-form') return true;
    return !!(form.action && form.action.indexOf('/cart/add') !== -1);
  }

  document.addEventListener('submit', function (e) {
    if (!isAddToCartForm(e.target)) return;
    if (!hasAnyFields() || !whatIsMissing()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    refresh();
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.shopify-payment-button, .product-form__buttons--payment')) return;
    if (!hasAnyFields() || !whatIsMissing()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    refresh();
  }, true);

  /* ------------------------------------------------------------------- boot */

  function boot() {
    if (!hasAnyFields()) return;

    refresh();

    /* typing in a text field */
    document.addEventListener('input', function (e) {
      if (e.target && e.target.name && e.target.name.indexOf('properties[') === 0) refresh();
    }, true);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'file') setTimeout(refresh, 400);
    }, true);

    /* An upload fills its hidden input from script, with no event we can
       listen for. The previous version handled that with
       setInterval(refresh, 1000) and no clear, plus a subtree observer over
       the whole product area — on a page where four apps mutate the DOM
       constantly that was a steady drain for the entire visit.

       Now: watch the two inputs that can actually change, and poll only
       while an upload is genuinely in flight. */
    function watchProperty(sel) {
      var node = document.querySelector(sel);
      if (!node) return;
      new MutationObserver(refresh).observe(node, {
        attributes: true, attributeFilter: ['value']
      });
    }
    watchProperty('input[name="properties[Custom Image]"]');
    watchProperty('input[name="properties[Image]"]');

    var pollTimer = null;
    document.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'file') return;
      if (pollTimer) clearInterval(pollTimer);
      var started = Date.now();
      pollTimer = setInterval(function () {
        refresh();
        if (!imageMissing() || Date.now() - started > 120000) {
          clearInterval(pollTimer);
          pollTimer = null;
        }
      }, 500);
    }, true);

    /* The product form is replaced on variant change, which removes the
       notice. Rebuild it then, and only then. */
    var host = document.querySelector('product-info, .product__info-container');
    if (host) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; refresh(); }, 200);
      }).observe(host, { childList: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();